import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router";
import { ArrowIcon } from "~/components/Base/ArrowIcon/ArrowIcon";

import "./UnansweredQuestionsListItem.css";

export function UnansweredQuestionsListItem({
  eventId,
  page,
  oid,
  label,
  onGoToQuestion,
}) {
  const { t } = useTranslation();

  // A <button> only allows phrasing content, so the heading is downgraded to
  // a <div> there; the link variant keeps the <h3> (anchors are transparent).
  const LabelTag = eventId ? "h3" : "div";

  const content = (
    <>
      <div>
        <div className="unanswered-question__header">
          {t("form.submit.unanswered_question")}
        </div>
        <LabelTag className="unanswered-question__label">{label}</LabelTag>
      </div>
      <ArrowIcon />
    </>
  );

  // A deep link is the better affordance — it survives a reload and supports
  // open-in-new-tab — but it needs an /events/:eventId URL to point at. Preview
  // has no such route, so linking there produced /events/undefined/... and
  // bounced the user to the IdP login. Fall back to an in-app jump instead.
  if (!eventId) {
    return (
      <button
        type="button"
        className="unanswered-question unanswered-question--button"
        onClick={() => onGoToQuestion(page, oid)}
      >
        {content}
      </button>
    );
  }

  return (
    <RouterLink
      className="unanswered-question"
      to={`/events/${eventId}/form/${page}?validate=true#${oid}`}
    >
      {content}
    </RouterLink>
  );
}

UnansweredQuestionsListItem.propTypes = {
  eventId: PropTypes.string,
  page: PropTypes.number.isRequired,
  oid: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onGoToQuestion: PropTypes.func.isRequired,
};
